import { AgnesBadge, AgnesBadgeProps, cn } from '@agnes/ui';
import { cva, VariantProps } from 'class-variance-authority';
import {
  RUBRICA_SITUACAO_NOMES,
  RubricaSituacao,
} from '@/constants/rubricas/situacao/RubricaSituacao';

const badgeCVA = cva('whitespace-nowrap', {
  variants: {
    situacao: {
      ATIVA:
        'bg-agnes-success/10 dark:bg-agnes-success/30 text-agnes-success dark:text-agnes-success-light',
      INATIVA:
        'bg-agnes-neutral/10 dark:bg-agnes-neutral/30 text-agnes-primary dark:text-agnes-primary-light',
      EXCLUIDA:
        'bg-agnes-error/10 dark:bg-agnes-error/30 text-agnes-error dark:text-agnes-error-light',
      NAO_UTILIZADA:
        'bg-agnes-neutral/10 dark:bg-agnes-neutral/30 text-agnes-neutral dark:text-agnes-primary-light',
      DESCONHECIDA:
        'bg-agnes-neutral/10 dark:bg-agnes-neutral/30 text-agnes-neutral dark:text-agnes-primary-light',
    },
  },
});

export interface BadgeRubricaSituacaoProps
  extends VariantProps<typeof badgeCVA>, Omit<AgnesBadgeProps, 'children'> {
  situacao: RubricaSituacao;
}

export function BadgeRubricaSituacao({
  className,
  situacao,
  size,
  ...props
}: BadgeRubricaSituacaoProps) {
  return (
    <AgnesBadge className={cn(badgeCVA({ situacao }), className)} size={size} {...props}>
      {RUBRICA_SITUACAO_NOMES[situacao]}
    </AgnesBadge>
  );
}
